module.exports = __webpack_public_path__ + "static/img/poornetwork@2x.0ce0e08.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/poornetwork@2x.png
// module id = kasR
// module chunks = 18